'use strict';

/**
 * View for rendering a single set in drag and drop mode
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/navigation-sets-dnd-list-item.hbs');

var NavigationSetsDndListItemView = ItemView.extend({
    template: template,

    tagName: 'li',

    attributes: function() {
        return {
            'data-id': this.model.id,
        }
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.$el.humansDrop({
            overClass: 'drop-target-over',
            accept: '.box-object-object',
            onDrop: function(event, humansDrop, humansDrag, element) {
                var catalog = this.model.collection.catalog;
                var objectId = humansDrag.getTargetElement().data('id');
                var objectModel = catalog.objects.get(objectId);

                App.radio('collection').execute(
                    'add:to:set',
                    objectModel,
                    this.model
                );
            }.bind(this),

            onOver: function(event, humansDrop, humansDrag, element) {
                $('#nav').addClass('has-drag-inside');
            },

            onLeave: function(event, humansDrop, humansDrag, element) {
                $('#nav').removeClass('has-drag-inside');
            },
        });
    },
});

module.exports = NavigationSetsDndListItemView;